export default "__VITE_ASSET__CwpbTlos__"